import React from "react";
import {Link} from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import _ from 'lodash';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';
import {geocodeByAddress, getLatLng} from 'react-places-autocomplete';

import {getLocations, updateLocation, deleteLocation} from '../../../actions/locationActions';
import { getHeader } from "../../../helper";
import LocationItem from "./LocationItem";
import LocationTrackerItem from "./LocationTrackerItem";
import CreateForm from "./CreateForm";
import CreateFormTracker from "./CreateFormTracker";
import { fetchInfo } from "../../../actions";

class Locations extends React.Component {

    state = {
        handleMore: false,
        screen: 'list',
        locationSelected: null,
        isFetching: false,
    }

    componentWillMount() {
        const { dispatch } = this.props;

        dispatch(getLocations());

        dispatch(fetchInfo([
            {
                query: 'settings',
                params: {},
            }
        ]));
    }

    componentWillReceiveProps(nextProps) {
        let prevIsFetching = this.props.locations.isFetching;

        if(prevIsFetching && !nextProps.locations.isFetching && this.state.handleMore) {
            this.setState({
                handleMore: false
            });
        }
    }

    handleMoreRecords(next) {
        if(!next) return false;

        this.setState({
            handleMore: true,
        });

        const { dispatch } = this.props;

        dispatch(getLocations({uri: next}));
    }

    handleOnChange(value, field) {
        const {locationSelected} = this.state;
        if(!locationSelected) return false;

        this.setState({
            locationSelected: {
                ...this.state.locationSelected,
                [field]: value
            }
        })
    }

    handleAddressText(_address) {
        const {locationSelected} = this.state;
        if(!locationSelected) return false;

        if (!_address.trim()) {
            this.setState({
                locationSelected: {
                    ...this.state.locationSelected,
                    address: "",
                    latitude: null,
                    longitude: null
                }
            })
            return;
        }

        this.setState({
            locationSelected: {
                ...this.state.locationSelected,
                latitude: null,
                longitude: null,
                address: _address
            }
           // checkChanged: true,
        })
    }

    getGeoCodeByAddress(address) {
        geocodeByAddress(address)
        .then(results => {
            return getLatLng(results[0])
        })
        .then(latLng =>
            this.handleChangeAddress(address, latLng)
        )
        .catch(error => console.error('Error', error))
    }

    handleChangeAddress(address, pos) {
        this.setState({
            locationSelected: {
                ...this.state.locationSelected,
                address: address,
                latitude: pos.lat,
                longitude: pos.lng,
                radius: '10'
            }
        }, () => {
            //if(this.state.isMap) this.initMap();
        })
    }

    handleCancel(e) {
        e.preventDefault();

        this.setState({
            screen: 'list',
            locationSelected: null,
        })
    }

    handleDelete(location) {
        if(!location) return false;

        this.props.dispatch(
            deleteLocation(
                location,
                (data) => {
                    Alert.success('Адрес успешно удален', {
                        position: 'bottom-left',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                },
                (message) => {
                    Alert.error(message, {
                        position: 'bottom-left',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                }
            )
        )
    }

    onSubmit(e, tracker = false) {
        e.preventDefault();
        const {locationSelected} = this.state;

        if(!locationSelected) return false;

        this.setState({isFetching: true});

        this.props.dispatch(updateLocation(
            {
                ...locationSelected,
                address: locationSelected.address || "Автоопределение",
            },
            (data) => {
                this.setState({
                    screen: 'list',
                    locationSelected: null,
                    isFetching: false
                });
                Alert.success('Адрес успешно обновлен', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            },
            (message) => {
                Alert.error(message, {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
                this.setState({
                    isFetching: false
                })
            }
        ));
    }

    render() {

        const {
            session,
            locations,
        } = this.props;

        let settings = this.props.data['settings'];
        const {isFetchingMore, next, isUpdating} = locations;
        let locationsArray = _.values(locations.data);
        locationsArray = _.orderBy(locationsArray, ['id'],['desc']);

        return(
            <div className="right-content native-scroll right-content-width">
                <div className="screen-outer-block-wrap native-scroll menu-content">
                    <div className="menu-content-balance menu-content-item tab-parent screen-bottom-block">

                        <Alert stack={{limit: 1}} />
                    
                        <div className="rounded-white-block">

                            {
                                this.state.screen === 'list' ?
                                <div>
                                    <div className="tab-content profile-info tab-content1 active">
                                    {
                                        !locations.count ?
                                        <div className="my-balance" style={{marginTop: 0,marginBottom: 0, display:'flex', paddingTop: '30px'}}>
                                            <div className="balance-state" style={{width:'100%'}}>
                                                <h3 style={{fontSize:'15px'}}>{`Список адресов пуст`}</h3>

                                                <div className="my-balance-actions" style={{width:'auto'}}>
                                                    <div className="big-button orange-button-gradient balance-btn">
                                                        <Link to="/account/locations/create">
                                                            <button>Добавить адрес</button>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="my-balance" style={{marginTop: 0,marginBottom: 0, display:'flex', paddingTop: '30px'}}>
                                            <div className="balance-state" style={{width:'100%'}}>
                                                <h3 style={{fontSize:'15px'}}>{`Количество адресов: ${locations.count}`}</h3>

                                                <div className="my-balance-actions" style={{width:'auto'}}>
                                                    <div className="big-button orange-button-gradient balance-btn">
                                                        <Link to="/account/locations/create">
                                                            <button>Добавить адрес</button>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    </div>

                                    <ul className="location-list">
                                        {
                                            locationsArray.map((location, index) => {
                                                if(location.camera_id) {
                                                    return  <LocationTrackerItem
                                                                key={index}
                                                                location={location}
                                                                handleEdit={(item) => this.setState({screen: 'edit', locationSelected: item})}
                                                                handleDelete={(item) => this.handleDelete(item)}
                                                            />
                                                }

                                                return  <LocationItem
                                                            key={index}
                                                            location={location}
                                                            handleEdit={(item) => this.setState({screen: 'edit', locationSelected: item})}
                                                            handleDelete={(item) => this.handleDelete(item)}
                                                        />
                                            })
                                        }
                                    </ul>
                                </div>
                                :
                                <div className="tab-content profile-info tab-content1 active">
                                    <div className="menu-content-staff menu-content-item tab-parent screen-bottom-block">

                                        <div className="rounded-white-block">
                                            <div className="white-block-top">
                                                <h3>Редактирование адреса</h3>
                                            </div>

                                            {
                                                this.state.locationSelected.camera_id
                                                ?
                                                <CreateFormTracker
                                                    {...this.state.locationSelected}
                                                    state="update"
                                                    isFetching={this.state.isUpdating}
                                                    handleOnChange={(value, field) => this.handleOnChange(value, field)}
                                                    onSubmit={(e) => this.onSubmit(e, true)}
                                                    handleCancel={(e) => this.handleCancel(e)}
                                                />
                                                :
                                                <CreateForm
                                                    {...this.state.locationSelected}
                                                    state="update"
                                                    isFetching={this.state.isUpdating}
                                                    handleAddressText={(address) => this.handleAddressText(address)}
                                                    handleOnChange={(value, field) => this.handleOnChange(value, field)}
                                                    getGeoCodeByAddress={(address) => this.getGeoCodeByAddress(address)}
                                                    onSubmit={(e) => this.onSubmit(e)}
                                                    handleCancel={(e) => this.handleCancel(e)}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            }

                        </div>
                        {
                            locations.next ?
                            <div className="big-button without-shadow button-action" style={{height:"auto", textAlign:"center",marginTop:"30px",marginBottom:"30px"}}>
                                <button className={isFetchingMore ? 'disabled' : ''}
                                    onClick={() => this.handleMoreRecords(locations.next)}>
                                    {isFetchingMore ? 'Загружается...' : 'Загрузить еще'}
                                </button>
                            </div>
                            : ''
                        }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};
  
export default connect(mapStateToProps)(Locations);


// WEBPACK FOOTER //
// ./src/components/Account/Locations/index.js